import { useEffect, useState } from "react";
import { _BudgetAccountantOperation, _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _PaymentItems } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BudgetAccountantOperationSelect } from "./BudgetAccountantOperationSelect";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectAccountanMovement } from "./BudgetAccountantMovement/SelectAccountanMovement";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";

interface Props {
    paymentHeader: any;
}

export const Paymentitems = ({ paymentHeader }: Props) => {

    const paymentitems = useDataBean(_PaymentItems);

    const single = Singleton.getInstance();
    const [accountantoperation, setAccountantoperation] = useState<any>(null);
    const [movement, setmovement] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [payitemstepone, setpayitemstepone] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [isProcessCreated, setIsProcessCreated] = useState(false);
    const [properties, setProperties] = useState<any>([]);
    const [Generated, setGenerated] = useState(false);

    const modalCreate = useModal("Crear", MODAL_md);
    const modalDelete = useModal("Eliminar Item", MODAL_SM);


    useEffect(() => {
        if (paymentHeader.IDPaymentHeader) {
            getLista();
        }
    }, [paymentHeader])

    useEffect(() => {
        if (movement) {
            paymentitems.instance.createPaymentItemByIDBudgetAccountantMovement(movement).then(
                (resp: any) => {
                    let temp = { ...properties };
                    if (resp) {
                        let keys = Object.keys(resp);
                        keys.forEach(key => {
                            temp[key] = resp[key];
                        });
                        setProperties(temp);
                    }
                }
            )
        }
    }, [movement])




    const createPaymentItems = () => {

        paymentitems.instance.createPaymentItem(paymentHeader.IDPaymentHeader, properties).then(
            (resp: any) => {
                if (resp) {
                    getLista();
                    modalCreate.close();

                }
            }
        )

    }
    const updatePaymentItems = () => {

        paymentitems.updateCustonBean(properties).then(
            (resp: any) => {
                if (resp) {
                    getLista();

                }
            }
        )
        modalCreate.close();

    }



    const getLista = () => {

        paymentitems.instance.getPaymentItemCatalog(paymentHeader.IDPaymentHeader).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }
    const deleteModal = () => {
        paymentitems.deleteItemVoid(paymentitems.bean.IDPaymentItem).then(
            (resp: any) => {
                toast.success("Item Eliminado");
                modalDelete.close();
            }

        )
    }
    const editarPaymentItem = () => {
        setmovement(paymentitems.bean.IDBudgetAccountantMovement);
        setProperties(paymentitems.bean);
        modalCreate.open();
    }


    const head = [
        { title: 'ID', property: 'IDPaymentItem', visible: true },
        { title: 'Código', property: 'MovementCode', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceCode', visible: true },
        { title: 'Fuente', property: 'BudgetSourceCode', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Tipo Movimiento', property: 'MovementNature', visible: true },
        { title: 'Valor', property: 'BaseValue', visible: true },
        { title: 'Identificación Tercero', property: 'Nit', visible: true },
        { title: 'Nombres', property: 'Names', visible: true },
        { title: 'Apellidos', property: 'Surnames', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: () => { setProperties({}); modalCreate.open() } }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: editarPaymentItem },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { editarPaymentItem() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={paymentitems.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                <Modal modal={modalCreate.modal} updateModal={modalCreate.setModal} eventModal={properties.IDPaymentItem > 0 ? updatePaymentItems : createPaymentItems}>
                    <div className="row">
                        <div className="col-md-6">
                            {properties.IDPaymentItem}
                            <SelectAccountanMovement idBudgetAccountantOperation={paymentHeader.IDBudgetAccountantOperation} idSelector={movement} onChange={(e) => setmovement(e)} />
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                {Object.keys(properties).map((row) => {
                                    return (
                                        <div className="col-md-6">
                                            <label>{row}</label>
                                            <input type="text" className="form-control" value={properties[row]}
                                                onChange={(e) => { setProperties({ ...properties, [row]: e.target.value }) }} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteModal}>
                    Eliminar Item
                </ModalConfirm>



            </div>

        </div>
    )
}